
    var riot = require('riot')
    //src: starling/src/tags/modal-import.html
riot.tag2('modal-import',
  '<div class="modal-background" onclick="{handleBackgroundClick}" style="display: none;"></div> <div ref="importProgress" class="import-progress_container" style="display: none;"> <div class="import-progress_label">Importing {getImportProgress()}%</div> <div class="progressbar import-progress_progressbar"> <div class="progressbar_fill" riot-style="width: {getImportProgress()}%;"></div> </div> <button onclick="{handleAbortImport}" class="Button Button--Small Button--Outlined">Cancel</button> </div> <div id="import-modal" ref="modal" class="modal fade" tabindex="-1" role="dialog" style="display: none;" onclick="{handleModalClick}"> <div class="modal-dialog" role="document"> <div ref="modalCurtain" class="modal-curtain" style="display: none;"></div> <div ref="modalContent" class="modal-content"> <div if="{!this.fileLoaded()}" class="modal-header"> <h2 class="modal-title">Import data as cards…</h2> <button class="modal-close" onclick="{handleCancelClick}"> <i class="modal-close_icon material-icons">close</i> </button> </div> <div if="{fileLoaded()}" class="modal-header"> <div class="modal-header_title"> <h2 class="modal-title">Import data from {this.getFileName()}</h2> </div> <div class="option-container"> <div class="option-toggle" onclick="{handleToggleOptionPanel}"> <i class="material-icons">settings</i> <span>Import settings</span> </div> <div ref="optionPanel" class="option-panel hidden" onclick="{ignoreClicks}"> <div class="option-panel_section"> <div class="option-panel_section-label">Separator type</div> <ul class="option-panel_list"> <li> <input type="radio" id="separator-type1" name="separator-type" value="auto" onclick="{handleUpdateImportSettings}" checked="{separatorTypeChecked(\'auto\')}"> <label class="option-panel_item-label" for="separator-type1" onclick="{handleUpdateImportSettings}">Automatic</label> </li> <li> <input type="radio" id="separator-type2" name="separator-type" value="comma" onclick="{handleUpdateImportSettings}" checked="{separatorTypeChecked(\'comma\')}"> <label class="option-panel_item-label" for="separator-type2" onclick="{handleUpdateImportSettings}">Comma</label> </li> <li> <input type="radio" id="separator-type3" name="separator-type" value="tab" onclick="{handleUpdateImportSettings}" checked="{separatorTypeChecked(\'tab\')}"> <label class="option-panel_item-label" for="separator-type3" onclick="{handleUpdateImportSettings}">Tab</label> </li> <li> <input type="radio" id="separator-type4" name="separator-type" value="custom" onclick="{handleUpdateImportSettings}" checked="{separatorTypeChecked(\'custom\')}"> <label class="option-panel_item-label" for="separator-type4">Other:</label> <input type="text" name="separator-type-custom" class="form-control mrgn-l-8" size="1" maxlength="1" onkeydown="{handleCustomSeparatorKeyDown}" onkeyup="{handleCustomSeparatorKeyUp}"> </li> </ul> </div> <div class="option-panel_section"> <div class="option-panel_section-label">Data format</div> <ul class="option-panel_list"> <li> <input type="checkbox" id="header-row-checkbox" name="header-row-option" onclick="{handleUpdateHeaderField}" checked="{this.getHeaderOption() ? \'checked\' : \'\'}"> <label class="option-panel_item-label" for="header-row-checkbox" onclick="{handleUpdateHeaderField}">Include header row</label> </li> <li> <input type="checkbox" id="show-field-in-card-checkbox" name="show-field-in-card" onclick="{handleUpdateShowFieldInCard}" checked="{this.getShowFieldInCardOption() ? \'checked\' : \'\'}"> <label class="option-panel_item-label" for="show-field-in-card-checkbox" onclick="{handleUpdateShowFieldInCard}">Include field names in card</label> </li> </ul> </div> </div> </div> <button class="modal-close" onclick="{handleCancelClick}"> <i class="modal-close_icon material-icons">close</i> </button> </div> <p if="{fileLoaded()}" class="import-summary"> {getFields().length} columns and {getRowCount()} rows found </p> <div class="spinner" ref="spinner"> <div class="bounce1"></div> <div class="bounce2"></div> <div class="bounce3"></div> </div> <div if="{!fileLoaded()}" class="modal-body"> <label for="import-file-input"> <div class="dropzone-container"> <div ref="dropzone" class="drop-zone" ondragover="{handleDragOver}" ondrop="{handleDrop}" ondragenter="{handleDragEnter}" ondragleave="{handleDragLeave}"></div> </div> <form> <input type="file" id="import-file-input" style="display:none"> </form> </label> </div> <div if="{fileLoaded()}" class="modal-body"> <div class="import-cols"> <div each="{field in this.getFields()}" class="import-col"> <div class="import-col_checkbox"> <input type="checkbox" class="checkbox plain" name="{getFieldId(field)}" onchange="{changeFieldInclusion.bind(this, field)}" checked="{fieldIsChecked(field) ? ⁗checked⁗ : \'\'}"> </div> <div class="import-col_name">{field}</div> <div class="import-col_label">is</div> <div class="import-col_type"> <div class="select-container"> <select id="{this.getFieldId(field)}-type" onchange="{this.changeFieldType.bind(this,field)}"> <option each="{type in this.fieldTypeOptions(field)}" riot-value="{type}" selected="{parent.fieldTypeSelected(field,type)}">{type}</option> </select> </div> </div> <div class="import-col_dest"> <span hide="{this.hideFieldTargetOption(field)}"> <span class="import-col_label">on</span> <div class="select-container"> <select id="{this.getFieldId(field)}-target" onchange="{this.changeFieldTarget.bind(this,field)}"> <option each="{target in this.getTargetOptions(field)}" riot-value="{target}" selected="{parent.fieldTargetSelected(field,target)}">{target}</option> </select> </div> </span> </div> </div> </div> <div class="import-card-preview"> <import-preview-card instance="{this}" each="{this.getTopLevelCards()}"></import-preview-card> </div> </div> <div class="modal-footer" show="{fileLoaded()}"> <button onclick="{handleCancelClick}" class="Button Button--Small Button--Outlined">Cancel</button> <button onclick="{importToMap}" ref="importButton" class="Button Button--Small Button--Primary">Import</button> </div> </div> </div> </div>',
  '',
  'ref="root"', function(opts) {
'use strict';

var _this = this;

var _nodesUi = require('lib/nodes-ui');

var _appUi = require('lib/app-ui');

var _importUi = require('lib/import-ui');

var _constants = require('lib/constants');

var _papaparse = require('papaparse');

var _papaparse2 = _interopRequireDefault(_papaparse);

var _eventTracking = require('lib/event-tracking');

var _eventTracking2 = _interopRequireDefault(_eventTracking);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

var md5 = require('md5');

var self = this;
this.canvas = this.opts.canvas;
this.operation = this.canvas.operation;
this.canvas.importModal = this;
this.file = null;
this.separatorType = 'auto';
this.delimiter = '';
this.eventCategory = 'Import-CSV';

this.show = function () {
  _this.resetModalSize();
  _this.refs.modal.classList.remove('large');
  _this.canvas.searchModal.dismiss();
  $('modal-import .modal-background').fadeIn();
  $('modal-import .modal').fadeIn();
  _this.refs.importButton.classList.remove('disabled');
  _this.cleanupBeforeShow();
  _this.update();
};

this.cleanupBeforeShow = function () {
  _this.addFileInputListener();
  if (_this.refs.dropzone) {
    _this.refs.dropzone.classList.remove('dragged-over');
  }
  _this.canvas.hidePopups();
  _this.stopSpinner();
};

this.dismiss = function (e) {
  if (_this.refs.dropzone) {
    _this.refs.dropzone.classList.remove('dragged-over');
    _this.refs.dropzone.classList.remove('file-type-error');
  }
  _this.stopSpinner();
  $('.modal-background').fadeOut();
  $('.modal').fadeOut();
  if (e) {
    e.preventDefault();
    e.stopPropagation();
  }
  _importUi.importUI.reset();
  _this.file = null;
  _this.separatorType = 'auto';
  _this.delimiter = '';
  _this.hideProgress();
  $('#import-file-input').val('');
};

this.resetModalSize = function () {
  _this.refs.modalContent.style.maxWidth = '';
  _this.refs.modalContent.style.width = '';
};

this.startSpinner = function () {
  _this.refs.modalCurtain.style.display = '';
  if (_this.refs.spinner) {
    _this.refs.spinner.classList.add('spinning');
  }
};

this.stopSpinner = function () {
  _this.refs.modalCurtain.style.display = 'none';
  if (_this.refs.spinner) {
    _this.refs.spinner.classList.remove('spinning');
  }
};

this.getHeaderOption = function () {
  return _importUi.importUI.headerOption;
};

this.getShowFieldInCardOption = function () {
  return _importUi.importUI.showFieldInCardOption;
};

this.separatorTypeChecked = function (type) {
  if (_this.separatorType === type) return 'checked';
  return '';
};

this.handleToggleOptionPanel = function (e) {
  _eventTracking2.default.track({
    category: _this.eventCategory,
    action: 'Import-Settings',
    label: 'Import-Settings-Toggle'
  });
  $(_this.refs.optionPanel).toggleClass('hidden');
  e.stopPropagation();
};

this.isOptionPanelOpen = function () {
  if (_this.refs.optionPanel && !$(_this.refs.optionPanel).hasClass('hidden')) return true;
  return false;
};

this.closeOptionPanel = function () {
  $(_this.refs.optionPanel).addClass('hidden');
};

this.handleCustomSeparatorKeyDown = function (e) {
  e.stopPropagation();
};

this.handleCustomSeparatorKeyUp = function (e) {
  e.stopPropagation();
  e.stopImmediatePropagation();
  var ENTER = _constants.KEY_CODES.ENTER;

  var delimiter = $("input[name='separator-type-custom']").val();
  var selectedSeparatorType = $("input[name='separator-type']:checked").val();
  if (delimiter.length && selectedSeparatorType !== 'custom') {
    _this.separatorType = 'custom';
    _this.update();
  }
  _this.handleUpdateImportSettings();
};

this.hideOptionPanel = function () {
  $(_this.refs.optionPanel).addClass('hidden');
};

this.ignoreClicks = function (e) {
  e.stopPropagation();
};

this.handleUpdateImportSettings = function (e) {
  if (e) {
    _eventTracking2.default.track({
      category: _this.eventCategory,
      action: 'Import-Settings',
      label: 'Change-Delimiter'
    });
    e.stopImmediatePropagation();
  }
  _importUi.importUI.reset();

  var selectedSeparatorType = $("input[name='separator-type']:checked").val();
  _this.separatorType = selectedSeparatorType;
  if (_this.separatorType === 'auto') {
    _this.delimiter = '';
  } else if (_this.separatorType === 'comma') {
    _this.delimiter = ',';
  } else if (_this.separatorType === 'tab') {
    _this.delimiter = "\t";
  } else if (_this.separatorType === 'custom') {
    _this.delimiter = $("input[name='separator-type-custom']").val();
  } else {
    _this.delimiter = '';
  }
  _this.processFile(_this.file);
};

this.handleUpdateHeaderField = function () {
  _importUi.importUI.reset();
  if (_this.getHeaderRowOptionChecked()) {
    _importUi.importUI.headerOption = true;
    _eventTracking2.default.track({
      category: _this.eventCategory,
      action: 'Import-Settings',
      label: 'Import-Setting-Header-On'
    });
  } else {
    _importUi.importUI.headerOption = false;
    _eventTracking2.default.track({
      category: _this.eventCategory,
      action: 'Import-Settings',
      label: 'Import-Setting-Header-Off'
    });
  }

  _this.processFile(_this.file);
};

this.handleUpdateShowFieldInCard = function () {
  if (_this.getShowFieldInCardOptionChecked()) {
    _importUi.importUI.showFieldInCardOption = true;
    _eventTracking2.default.track({
      category: _this.eventCategory,
      action: 'Import-Settings',
      label: 'Field-In-Card-On'
    });
  } else {
    _importUi.importUI.showFieldInCardOption = false;
    _eventTracking2.default.track({
      category: _this.eventCategory,
      action: 'Import-Settings',
      label: 'Field-In-Card-Off'
    });
  }
  _this.update();
};

this.getHeaderRowOptionChecked = function () {
  return $("input[name='header-row-option']").prop('checked');
};

this.getShowFieldInCardOptionChecked = function () {
  return $("input[name='show-field-in-card']").prop('checked');
};

this.getRowCount = function () {
  return _importUi.importUI.rows ? _importUi.importUI.rows.length : 0;
};

this.fileLoaded = function () {
  return _importUi.importUI.rows && _importUi.importUI.rows.length;
};

this.isOpen = function () {
  return $('#import-modal').is(':visible');
};

this.getFieldId = function (field) {
  return md5(field);
};

this.fieldTypeSelected = function (field, type) {
  if (_importUi.importUI.fieldTypes[field] === type) return true;
  return false;
};

this.fieldTargetSelected = function (field, target) {
  if (_importUi.importUI.fieldTargets[field] === target) return true;
  return false;
};

this.isTarget = function (field) {
  if (Object.values(_importUi.importUI.fieldTargets).includes(field)) return true;
  return false;
};

/* determine which types are valid to show for this field */
this.fieldTypeOptions = function (field) {
  var availableTypes = ['card'];

  var availablePartTargets = _importUi.importUI.getAvailablePartTargetsForField(field);
  if (availablePartTargets.length) {
    availableTypes.push('part');
  }

  /*
    if another field has the current one as the target,
    then this field must be a card or part;
    not an attribute or a summary
  */
  if (!_this.isTarget(field)) {
    availableTypes.push('attribute');

    var availableSummaryTargets = _importUi.importUI.getAvailableSummaryTargetsForField(field);
    if (availableSummaryTargets.length) {
      availableTypes.push('summary');
    }
  }
  return availableTypes;
};

this.changeFieldType = function (field) {
  _eventTracking2.default.track({
    category: _this.eventCategory,
    action: 'Import-Field-Option',
    label: 'Import-Change-Field-Type'
  });
  var type = $('#' + _this.getFieldId(field) + '-type').val();
  /* there has to be at least one column set to "card"  */
  if (_importUi.importUI.fieldTypes[field] === 'card' && type !== 'card' && _importUi.importUI.getCardTypes().length === 1 && _importUi.importUI.getCardTypes()[0] === field) {
    return;
  }

  _importUi.importUI.setFieldType(field, type);

  if (type !== 'card') {
    _this.changeFieldTarget(field);
  }
  _this.update();
};

this.changeFieldTarget = function (field, e) {
  if (e) {
    _eventTracking2.default.track({
      category: _this.eventCategory,
      action: 'Import-Field-Option',
      label: 'Import-Change-Field-Target'
    });
  }
  var target = $('#' + _this.getFieldId(field) + '-target').val();

  var availableFields = _this.getTargetOptions(field);

  if (target === undefined || !availableFields.includes(target)) {
    target = availableFields[0];
  }

  _importUi.importUI.setFieldTarget(field, target);
  _this.update();
};

this.hideFieldTargetOption = function (field) {
  if (_importUi.importUI.fieldTypes[field] === 'card') return true;
  return false;
};

this.getRow = function () {
  if (!_importUi.importUI.rows.length) return [];
  var cleanRow = {};
  for (var field in _importUi.importUI.rows[0]) {
    cleanRow[field.trim()] = _importUi.importUI.rows[0][field];
  }
  return cleanRow;
};

this.getTopLevelCards = function () {
  return _importUi.importUI.getTopLevelCards();
};

this.getPreviewPartsForCard = function (field) {
  var partFields = _importUi.importUI.getFieldsOfTypeOnTarget('part', field);
  var row = _this.getRow();
  return partFields.map(function (field) {
    return {
      field: field,
      value: row[field]
    };
  });
};

this.getPreviewAttributesForCard = function (field) {
  var attrFields = _importUi.importUI.getFieldsOfTypeOnTarget('attribute', field);
  var row = _this.getRow();
  return attrFields.map(function (field) {
    return {
      key: field,
      value: row[field]
    };
  });
};

this.changeFieldInclusion = function (field) {
  _eventTracking2.default.track({
    category: _this.eventCategory,
    action: 'Import-Field-Option',
    label: 'Import-Toggle-Field-Inclusion'
  });
  if (_importUi.importUI.fieldsIncluded[field]) {
    _importUi.importUI.fieldsIncluded[field] = false;
  } else {
    _importUi.importUI.fieldsIncluded[field] = true;
  }
  _this.resetInvalidSettings();
  _this.update();
};

this.resetInvalidSettings = function () {
  /* if a card has a non-included card as a target, reset its type*/
  for (var field in _importUi.importUI.fieldTargets) {
    var target = _importUi.importUI.fieldTargets[field];
    if (!_importUi.importUI.fieldsIncluded[target]) {
      delete _importUi.importUI.fieldTargets[field];
      _importUi.importUI.setFieldType(field, 'card');
    }
  }
};

this.fieldIsChecked = function (field) {
  if (_importUi.importUI.fieldsIncluded[field]) return true;
  return false;
};

this.getFields = function () {
  return _importUi.importUI.fields;
};

this.getTargetOptions = function (field) {
  var type = _importUi.importUI.fieldTypes[field];
  if (type === 'summary') {
    return _importUi.importUI.getAvailableSummaryTargetsForField(field);
  }
  if (type === 'part') {
    return _importUi.importUI.getAvailablePartTargetsForField(field);
  }
  if (type === 'attribute') {
    return _importUi.importUI.getAvailableAttributeTargetsForField(field);
  }
  return _importUi.importUI.getCardOrPartFields();
};

this.processFile = function (file) {
  _this.startSpinner();
  var errorCount = 0;

  _papaparse2.default.parse(file, {
    header: _importUi.importUI.headerOption,
    skipEmptyLines: true,
    delimiter: _this.delimiter,
    complete: function complete(results, file) {

      console.log("Done with file");
      _this.file = file;

      _importUi.importUI.setRows(results.data);

      if (results.meta && results.meta.fields) {
        var firstField = void 0;
        for (var _iterator = results.meta.fields, _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
          var _ref;

          if (_isArray) {
            if (_i >= _iterator.length) break;
            _ref = _iterator[_i++];
          } else {
            _i = _iterator.next();
            if (_i.done) break;
            _ref = _i.value;
          }

          var field = _ref;

          var cleanField = field.trim();

          if (!firstField) {
            _importUi.importUI.fieldTypes[cleanField] = 'card';
            firstField = cleanField;
          } else {
            _importUi.importUI.fieldTypes[cleanField] = _importUi.importUI.getSuggestedFieldType(cleanField);
            _importUi.importUI.fieldTargets[cleanField] = firstField;
          }
          _importUi.importUI.fieldsIncluded[cleanField] = true;
        }
        _importUi.importUI.setFields(results.meta.fields);
      } else {
        _importUi.importUI.fillInDefaultFields();
      }

      _this.update();
      _this.fixModalSize();
      _this.stopSpinner();
    },

    before: function before(file, inputElem) {
      console.log("Parsing file...", file);
    },
    error: function error(err, file) {
      console.log("ERROR:", err, file);
      errorCount++;
    }
  });
};

this.handleCancelClick = function () {
  _eventTracking2.default.track({
    category: _this.eventCategory,
    action: 'Import-Dismiss',
    label: 'Import-Dismiss'
  });
  if (_this.showingProgress) return;
  _this.dismiss();
};

this.importToMap = function () {
  _eventTracking2.default.track({
    category: _this.eventCategory,
    action: 'Import-Cards',
    label: 'Import-Cards'
  });
  _this.refs.importButton.classList.add('disabled');
  /* button doesn't change if this locks up the cpu right after... */
  setTimeout(function () {
    _this.showProgress();
    _importUi.importUI.csvToCards();
  }, 1);
};

this.getImportProgress = function () {
  return _importUi.importUI.importProgress;
};

this.handleAbortImport = function (e) {
  _importUi.importUI.triggerAbortImport();
};

this.showProgress = function () {
  _this.refs.importProgress.style.display = '';
  _this.refs.root.classList.add('import-in-progress');
  _this.showingProgress = true;
};

this.hideProgress = function () {
  _this.refs.importProgress.style.display = 'none';
  _this.refs.root.classList.remove('import-in-progress');
  _this.showingProgress = false;
};

this.importDone = function () {
  _this.hideProgress();
  _this.dismiss();
};

this.handleBackgroundClick = function (e) {
  if (_this.showingProgress) return;
  if (_this.isOptionPanelOpen()) {
    _this.closeOptionPanel();
    return;
  }
  _this.dismiss();
};

this.handleModalClick = function (e) {
  if (_this.isOptionPanelOpen()) {
    _this.closeOptionPanel();
    e.preventDefault();
    e.stopPropagation();
  }
};

/* parser retains spaces in field names :( */
this.cleanRow = function (_row) {
  var row = {};
  for (var field in _row) {
    row[field.trim()] = _row[field];
  }
  return row;
};

this.getFileName = function () {
  if (_this.file) {
    return _this.file.name;
  }
  return '';
};

this.handleDragOver = function (e) {
  e.preventDefault(); // necessary to make drop handler fire!
};

this.handleDragEnter = function (e) {
  _this.refs.dropzone.classList.add('dragged-over');
};

this.handleDragLeave = function (e) {
  _this.refs.dropzone.classList.remove('dragged-over');
};

this.handleDrop = function () {
  var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(e) {
    var dt, file, i;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            e.preventDefault();
            // If dropped items aren't files, reject them
            self.refs.dropzone.classList.remove('file-type-error');
            dt = e.dataTransfer;
            file = void 0;

            for (i = 0; i < dt.items.length; i++) {
              if (dt.items[i].kind == "file") {
                file = dt.items[i].getAsFile();
              }
            }
            _eventTracking2.default.track({
              category: _this.eventCategory,
              action: 'Import-File-Upload',
              label: 'Drop-File'
            });
            if (_importUi.importUI.isValidFileType(file)) {
              _importUi.importUI.reset();
              _this.resetModalSize();
              _this.file = file;
              _this.processFile(file);
            } else {
              self.refs.dropzone.classList.add('file-type-error');
            }
            _this.refs.dropzone.classList.remove('dragged-over');

          case 8:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, _this);
  }));

  return function (_x) {
    return _ref2.apply(this, arguments);
  };
}();

this.clearError = function () {
  clearTimeout(_this.clearErrorTimeout);
  _this.clearErrorTimeout = null;

  if (_this.refs.dropzone) {
    _this.refs.dropzone.classList.remove(_this.error);
    _this.error = null;
  }
};

this.addFileInputListener = function () {
  _this.clearError();
  var fileInput = document.getElementById('import-file-input');
  var handleFileInputChange = function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      var file;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              if (fileInput.files && fileInput.files[0]) {
                file = fileInput.files[0];

                _this.file = file;
                _eventTracking2.default.track({
                  category: _this.eventCategory,
                  action: 'Import-File-Upload',
                  label: 'Select-File'
                });
                if (_importUi.importUI.isValidFileType(file)) {
                  _importUi.importUI.reset();
                  _this.resetModalSize();
                  _this.file = file;
                  _this.processFile(file);
                } else {
                  self.refs.dropzone.classList.add('file-type-error');
                }
              }

            case 1:
            case 'end':
              return _context2.stop();
          }
        }
      }, _callee2, _this);
    }));

    return function handleFileInputChange() {
      return _ref3.apply(this, arguments);
    };
  }();

  if (fileInput) {
    fileInput.removeEventListener('change', handleFileInputChange);
    fileInput.addEventListener('change', handleFileInputChange);
  }
};

/*
  fix the width of the modal at its max so that if cards are removed, the preview won't shrink the whole modal
*/
this.fixModalSize = function () {
  var rect = _this.refs.modalContent.getBoundingClientRect();
  _this.refs.modalContent.style.maxWidth = rect.width + 'px';
  _this.refs.modalContent.style.width = rect.width + 'px';
  _this.refs.modal.classList.add('large');
};

this.on('updated', function () {
  _this.addFileInputListener();
});

this.on('mount', function () {
  _this.addFileInputListener();

  window.onresize = function () {
    if (_importUi.importUI.rows && _importUi.importUI.rows.length) {
      _this.refs.modalContent.style.maxWidth = '';
      _this.refs.modalContent.style.width = '';
      _this.fixModalSize();
    }
  };
});
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('modal-import')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/modal-import.html
// module id = 633
// module chunks = 0